module.exports = __webpack_public_path__ + "static/resource-hiring-remotely-f3767fd3865c7d2a3b12bb6ebe54eaff.png";